<template>
<el-form  :rules="rules" ref="gprsForm" :model="device.gprs" label-width="50%" label-position="left">
    
    
  </el-form>
</template>

<script>
import { post } from "../../../../../API/cloudFunctions";

export default {
  created() {
    if (this.$store.getters.smtpConfig) {
      this.smtp = this.$store.getters.smtpConfig;
    }
  },
  name: "gprs",
  data() {
    return {
      device: {
        gprs: {}
      },
      rules: {},
      loading: false,
      disablePassword: true,
      sendingTestEmail: false,
      sent: false
    };
  },
  methods: {
    authenticationChange(state) {
      if (state) {
        this.rules.userName = {
          required: true,
          message: "User name is required!",
          trigger: "change"
        };
        this.rules.password = { required: true, trigger: "change" };
      } else {
        this.smtp.userName = "";
        this.smtp.password = "";
        this.rules.userName = {};
        this.rules.password = {};
      }
    },
    configureSMTP() {
      this.$refs.smtpForm.validate(valid => {
        if (valid) {
          this.loading = true;
          post("updateUser", {
            id: this.$store.getters.currentUser.id,
            updates: { smtp: this.smtp }
          })
            .then(success => {
              this.loading = false;
              this.$message({
                message: "Congrats, SMTP  configured successfully.",
                type: "success"
              });
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                message: "Oops, an error has occurred, error:",
                error,
                type: "success"
              });
            });
        } else {
          return false;
        }
      });
    },
    togglePasswordChange() {
      this.disablePassword = !this.disablePassword;
    },
    sendTestEmail() {
      this.sendingTestEmail = true;
      this.sent = false;
      post("sendTestEmail", {
        smtp: this.smtp,
        testEmail: this.testEmail
      })
        .then(success => {
          this.sendingTestEmail = false;
          this.sent = false;
          this.$message({
            message: "your smtp configuration is working perfectly",
            type: "success"
          });
        })
        .catch(error => {
          this.sendingTestEmail = false;
          this.$message({
            message: "Oops,please check your SMTP  configuration!",
            type: "error"
          });
        });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/components/profile/configuration/gprs.vue